import { Company } from '../busqueda-empresa/interfaces/compani.inteface';

export function filter(text: string, usersCompanys) {
    if (!text) {
        return usersCompanys;
    }

    text = text.toLowerCase();

    // Filtrar usuarios con al menos una empresa que coincida con el término de búsqueda
    return usersCompanys
        .map((usuario) => {
            const empresasFiltradas = usuario.empresas.filter(
                (empresa) =>
                    (empresa?.nit || '').toLowerCase().includes(text) ||
                    (empresa.razonSocial || '').toLowerCase().includes(text)
            );

            if (
                empresasFiltradas.length > 0 ||
                (usuario?.representante?.nombre || '')
                    .toLowerCase()
                    .includes(text) ||
                (usuario?.representante?.email || '')
                    .toLowerCase()
                    .includes(text) ||
                (usuario?.representante?.estado || '')
                    .toLowerCase()
                    .includes(text)
            ) {
                return {
                    ...usuario,
                    empresas:
                        empresasFiltradas.length > 0
                            ? empresasFiltradas
                            : usuario.empresas,
                };
            }
            return null;
        })
        .filter((usuario) => usuario !== null);
}

export function filterEmpresas(text: string, empresas: Company[]): Company[] {
    if (!text) {
        return empresas;
    }

    text = text.toLowerCase();

    return empresas.filter(
        (empresa) =>
            (empresa?.nit || '').toLowerCase().includes(text) ||
            (empresa?.razonSocial || '').toLowerCase().includes(text) ||
            (empresa?.eslabon || '').toLowerCase().includes(text) ||
            (empresa?.tipo_producto_que_importa || '')
                .toLowerCase()
                .includes(text)
    );
}
